import React, { useEffect, useMemo, useState } from 'react';
import { FaSync } from 'react-icons/fa';
import { connect } from 'react-redux';
import api from '../../axios-local-api';
import Box from '../../hoc/Box/Box';
import { FaInfoCircle } from 'react-icons/fa';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import classes from './DeviceSteering.css';
import Spinner from '../../components/UI/Spinner/Spinner';
import DeviceIcon from '../../components/UI/DeviceIcon/DeviceIcon';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import SlidePanel from '../../components/UI/SlidePanel/SlidePanel';
import Success from '../../components/UI/Success/Success';
import DeviceDetails from '../DeviceList/DeviceDetails/DeviceDetails';
import DeviceSterringCountDownTimer from './DeviceSterringCountDownTimer/DeviceSterringCountDownTimer';
import { getDeviceName, getDeviceIconUrl, getDeviceModel, getSoftwareVersion } from '../../shared/common';
import Confirm from '../../../src/components/UI/Confirm/Confirm';

const DeviceSteering = (props) => {
  const [displaySteeringDevices, setdisplaySteeringDevices] = useState(false);
  const [displaySpinner, setdisplaySpinner] = useState(false);
  const [adding, setadding] = useState(false);
  const [showDeets, setshowDeets] = useState(null);
  const [deviceIconUrl, setdeviceIconUrl] = useState(null);
  const [deviceModel, setdeviceModel] = useState(null);
  const [softwareVersion, setsoftwareVersion] = useState(null);
  const [updatedCustomSchedule, setupdatedCustomSchedule] = useState(false);
  const [success, setsuccess] = useState(false);
  const [error, seterror] = useState(false);
  const [state, setState] = useState({ isConfirmModalOpen: false });
  const [steerAllDeviceModal, showSteerAllDeviceModal] = useState(false);

  useEffect(() => {
    if (props.currentShowDeets !== null) {
      if (props.devicesByEquipment && props.currentShowDeets?.mac) {
        props.devicesByEquipment.map((d) => {
          if (d.mac === props.currentShowDeets.mac) {
            if (d.freeze.frozen !== props.currentShowDeets.freeze.frozen
              || d.name !== props.currentShowDeets.name
              || d.freeze.timeTemplates.length !== props.currentShowDeets.freeze.timeTemplates.length
              || updatedCustomSchedule && props.success
            ) {
              setdisplaySteeringDevices(true);
              setadding(true);
              setshowDeets(d);
              setupdatedCustomSchedule(false);
              props.onGetAdvancedDevice(d.mac, 1);
              props.updateShowDeets(d);
            }
          }
        });
      }
    }
  }, [props.currentShowDeets]);

  useEffect(() => {
    if(displaySteeringDevices){
      if (props.error && !error) {
        seterror(true);
        props.onResetDevicesErrorSuccess();
      }
      if (props.success && !success) {
        setsuccess(true);
        props.onResetDevicesErrorSuccess();
        // console.log(props.selectedEquipment, "props.selectedEquipment props")
        props.onSetSelectedEquipment(props.selectedEquipment);
      }
    }
  }, [props.error, error, props.success, success, displaySteeringDevices])



  const refreshDeviceSteeringHandler = () => {
    // console.log("here 76")
    // API CALLING TO UPDATE THE STEERING DEVICES
    setdisplaySpinner(true);
    props.onRefreshDevices(props.selectedEquipment);
  }

  const getSteeringDevices = () => {
    if (props?.devicesByEquipment?.length) {
      setdisplaySteeringDevices(true);
      setdisplaySpinner(false);
    }
  }

  const getAdvancedDeviceIdsType = (showDeets) => {
    let advancedDeviceIdsType = 'Default';
    if (props.advancedDeviceIds && props.advancedDeviceIds[showDeets.mac] && props.advancedDeviceIds[showDeets.mac]['advancedDeviceId']) {
      advancedDeviceIdsType = props.advancedDeviceIds[showDeets.mac]['advancedDeviceId'].type;
    }
    return advancedDeviceIdsType;
  }

  const showDeviceDetails = (
    e,
    deviceIconUrl,
    deviceModel,
    softwareVersion
  ) => {
    setshowDeets(e);
    setadding(true);
    setdeviceIconUrl(deviceIconUrl);
    setdeviceModel(deviceModel);
    setsoftwareVersion(softwareVersion);
    props.onGetAdvancedDevice(e.mac, 1);
    props.updateShowDeets(e);
  };

  const modalCancelHandler = () => {
    setadding(false);
  };

  const resetDeviceHandler = () => {
    setdeviceReset(true);
    setTimeout(() => {
      setdeviceReset(false);
    }, 1);
  };

  const updateScheduleDetails = () => {
    setupdatedCustomSchedule(true);
  }

  const deviceSteeringList = useMemo(() => {
    if (props?.devicesByEquipment?.length) {

      return props.devicesByEquipment.map((element, index) => {
        if (element.steering && element.steering.forced) {
          const deviceIconUrl = getDeviceIconUrl(element.mac, props.advancedDeviceIds);
          const deviceModel = getDeviceModel(element.mac, 'fullName', props.advancedDeviceIds);
          const softwareVersion = getSoftwareVersion(element.mac, props.advancedDeviceIds);
          const remainingSterringTime = element?.steering?.forced?.expiresAt;
          const {deviceName} = getDeviceName(element, props.advancedDeviceIds);

          return (
            <tr>
              <td
                style={{
                  padding: '20px',
                  borderRight: 'none',
                  borderLeft: 'none',
                  borderBottom: '1px solid lightgray',
                  display: 'flex'
                }}
              >
                <DeviceIcon size={30} iconUrl={deviceIconUrl} />
                <span
                  id="deviceSteeringDeviceName"
                  className={[classes.devName, classes.RegularButton].join(' ')}
                  style={{
                    padding: '6px 6px 6px 7px',
                    cursor: 'pointer',
                    lineHeight: '1.5em',
                    height: '2em',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                  onClick={() =>
                    showDeviceDetails(
                      element,
                      deviceIconUrl,
                      deviceModel,
                      softwareVersion
                    )
                  }
                >
                  {deviceName}
                </span>
              </td >

              <td
                style={{
                  padding: '12px',
                  borderRight: 'none',
                  borderLeft: 'none',
                  borderBottom: '1px solid lightgray',
                }}
              >
                {
                  <DeviceSterringCountDownTimer
                    key={index}
                    expiresAt={remainingSterringTime}
                    handleTimeEnd={() => {
                      refreshDeviceSteeringHandler();
                      // window?.location?.reload();
                    }}
                  />
                }
              </td>
              <td
                style={{
                  padding: '12px',
                  borderRight: 'none',
                  borderLeft: 'none',
                  borderBottom: '1px solid lightgray',
                }}
              >
                <span
                  id="DeviceSteeringDeviceConnectedTo"
                  style={{
                    overflowWrap: 'break-word',
                    whiteSpace: 'pre',
                  }}
                >
                  2.4G
                </span>
              </td>

            </tr>
          );
        }
      });
    }
  },[props.devicesByEquipment, props.advancedDeviceIds])

  const steeringDevicesInfo = useMemo(() => {
    if(displaySteeringDevices){
      return (
        <div className={classes.tablewrapper}>
          <table
            className={classes.devTable}
            cellPadding="0"
            cellSpacing="0"
          >
            <thead>
              <tr>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '12px',
                    borderBottom: '1px solid lightgray',
                    cursor: 'pointer',
                  }}
                >
                  Device Name
                </th>

                <th
                  style={{ cursor: 'pointer', textAlign: 'left' }}
                  className={classes.steeringThTag}
                >
                  Time Remaining (mm:ss)
                </th>
                <th
                  style={{ cursor: 'pointer', textAlign: 'left' }}
                  className={classes.steeringThTag}
                >
                  Steering
                </th>
              </tr>
            </thead>
            <tbody>{deviceSteeringList}</tbody>
          </table>
        </div>
      )
    }
    },[displaySteeringDevices]);

  const deviceGroups = useMemo(() => {
    let groupMap = {};
    if (props.deviceGroups) {
      props.deviceGroups.forEach((group) => {
        if (!group.devices) return;
        group.devices.forEach((device) => {
          groupMap[device.mac] = group;
        });
      });
    }
    return groupMap;
  },[props.deviceGroups]);

  const successErrorResetHandler = () => {
    setsuccess(false);
    seterror(false);
    props.onResetDevicesErrorSuccess();
    props.onSetSelectedEquipment(props.selectedEquipment);
  };

const showDevIPModal = useMemo(() => {
    if (showDeets && adding) {
      let originalDevice = showDeets ? showDeets : null;
      const {deviceName} = getDeviceName(showDeets, props.advancedDeviceIds);

      let bandwidthM;
        if (
         props.devicesByEquipment &&
          props.devicesByEquipment.length &&
          props.bandwidth &&
          props.bandwidth.device
        ) {
          bandwidthM = props.bandwidth.device.find(
            (dev) => dev.deviceMAC === showDeets.mac
          );
        } else {
          bandwidthM = null;
        }
      let deviceGroupName =
        deviceGroups[originalDevice.mac] &&
          deviceGroups[originalDevice.mac].nickname
          ? deviceGroups[originalDevice.mac].nickname
          : '';
      let groupFreezeTemplate = originalDevice.freeze || false;

      if (!deviceGroupName) {
        deviceGroupName = 'Ungrouped';
      } else {
        originalDevice.freeze = groupFreezeTemplate;
      }

      let deviceStatus;

      if (showDeets?.connectionState === 'connected' &&
        showDeets?.freeze?.frozen === true
      ) {
        deviceStatus = 'Paused';
      } else if (showDeets?.health?.status) {
        deviceStatus =
          showDeets.health.status.charAt(0).toUpperCase() +
          showDeets.health.status.slice(1);
      } else {
        deviceStatus = 'Disconnected';
      }
      return (
        <div>
          <DeviceDetails
            originalDevice={originalDevice}
            devName={deviceName}
            signalStatus={deviceStatus}
            bandwidth={bandwidthM}
            isLoading={props.loading}
            devicesByEquipment={props.devicesByEquipment}
            resetDevice={resetDeviceHandler}
            modalCancel={modalCancelHandler}
            deviceIconUrl={deviceIconUrl}
            deviceModel={deviceModel}
            softwareVersion={softwareVersion}
            deviceGroupName={deviceGroupName}
            groupFreezeTemplate={groupFreezeTemplate}
            updateScheduleDetails={updateScheduleDetails}
            advancedDeviceIdsType={getAdvancedDeviceIdsType(showDeets)}
          />
        </div>
      );

    }else{
      return '';
    }
  },[showDeets, adding])

  const spinnerMsg = (
    <div className={classes.spinnerMsg}>
      <Spinner />
      <span style={{ textAlign: 'center', paddingBottom: '25px' }}> Gathering Devices Please wait.</span>
    </div>
  );

const errorModal = useMemo(() => {
  return (
      <Modal
        show={error}
        modalClosed={successErrorResetHandler}
      >
        <Error id={'DeviceSteeringError'} />
      </Modal>
  )
});

const successModal = useMemo(() => {
  return(
    <Modal
      show={success}
      modalClosed={successErrorResetHandler}
    >
      <Success id={'DeviceSteeringSuccess'} />
    </Modal>
  )
})

const sidePanelModal = useMemo(() => {
  return (
    <SlidePanel
      devDeets="true"
      show={adding}
      modalClosed={modalCancelHandler}
    >
      <button
        className={classes.RegularButton}
        id=' BackToDevicesList'
        style={{ marginTop: '2px' }}
        onClick={modalCancelHandler}
      >
        {'<'} Back To Devices List
      </button>
      {showDevIPModal}
      {error && errorModal}
      {success && successModal}
    </SlidePanel>
  )
},[adding, success, error, displaySteeringDevices])

  const confirmModalCancelHandler = () => {
    showSteerAllDeviceModal(false);
  }

  const confirmModalConfirmHandler = () => {
    showSteerAllDeviceModal(false);
    props?.onAllDeviceSteering(props.selectedEquipment);

  }

  const deviceSteeringAllConfirmationModal = (
    <Modal
      show
      modalClosed={confirmModalCancelHandler}
      customStyle={{ width: '62%',transform: 'translate(0px, 148px)', border: 'none',marginRight:'20px', borderRadius: '8px'
    }}
    >
        <div>
        <div style={{display:'flex',alignItems: 'center'}}>
          <span><FaInfoCircle color="#38a9f9" size={24} style={{ display: 'flex', marginRight: '5px', marginLeft: '5px'}} /></span>
          <h3  className={classes.SteeringAllButton}>Steering All Devices</h3>
          </div>
        <div className={classes.modalContent}>
          <div>This will steer all mobile phones, tablets and unidentified devices to 2.4 GHz for 30 minutes.This action may take some time to complete. During this time, some devices may disconnect. Please follow CO-Pilot article HOW5466 for further assistance.</div>
          <div style={{ marginTop: 10 }}>Do you wish to proceed?</div>
        </div>
        <footer style={{ marginTop: 24, display:'flex' }}>
          <button onClick={confirmModalConfirmHandler} className={classes.proceedButton}>Proceed</button>
          <button onClick={confirmModalCancelHandler} className={classes.cancelButton}>Cancel</button>
        </footer>
      </div>
    </Modal>
  );

  return (
    <Box>
      <div className={classes.DeviceSteering}>
        <div className={classes.TitleArea}>
          <div className={classes.TitleLeft}>
            <h3 id='DeviceSteeringText' style={{ paddingRight: 20 }}>Smart Steering </h3>
          </div>

          <div className={classes.TitleRight}>
            {displaySteeringDevices ?
              <button
                id="DeviceSteeringRefreshbtn"
                className={classes.RegularButton}
                onClick={() => { refreshDeviceSteeringHandler() }}
              >
                <FaSync />  Refresh
              </button> :
              <button
                className={classes.RegularButton}
                id='deviceSteeringViewDevice'
                disabled={props?.devicesByEquipment?.length > 0 ? false : true}
                onClick={() => {
                  setdisplaySpinner(true);
                  getSteeringDevices();
                }}
              >
                View Devices
              </button>

            }
             <span style={{ padding: '5px', color:'#0073d1'}}>|</span>
            <button
              className={classes.RegularButton}
              onClick={() => showSteerAllDeviceModal(true)}
              disabled = {props?.devicesByEquipment?.length > 0 ? false : true}
            >
              Smart Steer Devices
            </button>
            {steerAllDeviceModal && deviceSteeringAllConfirmationModal}
          </div>
        </div>
        {!(steerAllDeviceModal && deviceSteeringAllConfirmationModal) && (
            <div className={[classes.alertMessageContainer].join(' ')}>
              <span>
                <FaInfoCircle color='#38a9f9' size={24} />
              </span>
              <span id='SteeringMsg' className={classes.alertMessage}>
                  Smart Steer will steer mobile phones, tablets and unidentified devices to 2.4 GHz for 30 minutes.
              </span>
            </div>
          )}
        <div className={classes.Separator} />
        {(displaySpinner || props.poolDeviceSteeringLoading) && spinnerMsg}
        {displaySteeringDevices && steeringDevicesInfo}
      </div>
      {displaySteeringDevices && sidePanelModal}
      {props.pollDeviceSteeringFailed &&
        <Modal
          show={props.pollDeviceSteeringFailed}
          modalClosed={props.onResetDevicesSteeringErrorSuccess}
        >
          <Error id={'pollDeviceSteeringError'}  showOldView  />
        </Modal>
      }
      {props.pollDeviceSteeringSuccess &&
        <Modal
          show={props.pollDeviceSteeringSuccess}
          modalClosed={props.onResetDevicesSteeringErrorSuccess}
        >
          <Success id={'pollDeviceSteeringSuccess'} />
        </Modal>
      }

    </Box>
  )
}

const mapStateToProps = state => ({
  loading: state.devices.loading,
  success: state.devices.success,
  error: state.devices.error,
  selectedEquipment: state.equipment.selectedEquipment,
  advancedDeviceIds: state.devices.advancedDeviceIds,
  deviceGroups: state.deviceGroups.deviceGroups,
  bandwidth: state.bandwidth.realBandwidth,
  devicesByEquipment: state.devices.devicesByEquipment,
  pollDeviceSteeringLoading: state.deviceSteering.pollDeviceSteeringLoading,
  pollDeviceSteeringSuccess: state.deviceSteering.pollDeviceSteeringSuccess,
  pollDeviceSteeringFailed: state.deviceSteering.pollDeviceSteeringFailed
})

const mapDispatchToProps = (dispatch) => {
  return {
    onGetAdvancedDevice: (deviceMac, days) => {
      dispatch(actions.getAdvancedDevice(deviceMac, days));
    },
    onResetDevicesErrorSuccess: () => dispatch(actions.resetDevicesErrorSuccess()),
    onSetSelectedEquipment: (equipment) => {
      dispatch(actions.setSelectedEquipment(equipment));
    },
    onResetDevicesSteeringErrorSuccess: () => dispatch(actions.resetDevicesSteeringErrorSuccess()),
    onRefreshDevices: (selectedEquipment) => dispatch(actions.refreshDevices(selectedEquipment)),
    onAllDeviceSteering: (selectedEquipment) => dispatch(actions.startSteeringAll(selectedEquipment)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(DeviceSteering, api));

